export const ADD_TO_CART = 'ADD_TO_CART'
export const EDIT_TO_CART = 'EDIT_TO_CART'
export const DELETE_TO_CART = 'DELETE_TO_CART'
export const CHECKOUT = 'CHECKOUT'
export const SAVE_TO_CART = 'SAVE_TO_CART'
export const SAVE_ACTIVITY_ITEM = 'SAVE_ACTIVITY_ITEM'



// WEBPACK FOOTER //
// ./src/store/cart/mutations_types.js